
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class BottomDialog extends Vue {
  @Prop(Boolean) model: boolean | undefined;
  @Prop(String) contentClass: string | undefined;
}
